import { AssetType, BackendUploadData } from './assetsTypes'

export type UploadedData = {
  url: string
  signedUrl: string
}

export default async function upload(
  type: AssetType,
  id: number,
  file: Blob
): Promise<UploadedData> {
  return uploadAttempt(type, id, file, 1)
}

const uploadAttempt = async (
  type: AssetType,
  id: number,
  file: Blob,
  attempt: number
): Promise<UploadedData> => {
  try {
    const { signedPut, signedGet, urlToSave } = await getSignedUrl(type, id)

    const response = await fetch(signedPut, {
      method: 'PUT',
      body: file,
      headers: {
        'Cache-Control': 'public, max-age=86400, immutable',
      },
    })

    if (response.status !== 200) {
      throw new Error(`Status 200 expected, got ${response.status}`)
    }

    return {
      url: `${urlToSave}?cacheKey=${Date.now()}`,
      signedUrl: signedGet,
    } as UploadedData
  } catch (err: unknown) {
    if (attempt < 3) {
      return uploadAttempt(type, id, file, ++attempt)
    }
    throw err
  }
}

/**
 * Return AWS urls for HTTP methods.
 * @param path
 * @param isPublic
 */
async function getSignedUrl(
  type: AssetType,
  id: number
): Promise<BackendUploadData> {
  const response = await fetch(
    `${window.RWJS_API_URL}/getSignedUrl?${new URLSearchParams({
      type,
      id: `${id}`,
    })}`
  )

  const { data } = JSON.parse(await response.text())
  return data
}

/**
 *
 * @param file
 * @returns
 */
export const readFile = (file: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.addEventListener('error', (err) => reject(err), false)

    reader.readAsDataURL(file)
  })
